import { de, type MessageKey } from './de.ts';
import { en } from './en.ts';

// German is the default; English is prepared (PROMPT.md §5) and falls back to German.
const dictionaries = { de, en } as const;
export type Locale = keyof typeof dictionaries;

let locale: Locale = 'de';

export function setLocale(next: Locale): void {
  locale = next;
  document.documentElement.lang = next;
}

export function t(key: MessageKey, params?: Record<string, string | number>): string {
  const dictionary: Partial<Record<MessageKey, string>> = dictionaries[locale];
  let text = dictionary[key] ?? de[key];
  if (params) {
    for (const [name, value] of Object.entries(params)) text = text.replace(`{${name}}`, String(value));
  }
  return text;
}

export type { MessageKey };
